import React from "react";
import { useTranslation } from "react-i18next";
import "./other.css";
import Header from "components/Header";
import EwhLogo from "assets/images/ewh-logo.png";
import SurgicalLampImage from "assets/images/repair_surgical_lamp.jpg";
import CircuitImage from "assets/images/circuit.jpg";
import AfterSignImage from "assets/images/after_signs.png";
import SignsLowImage from "assets/images/signs_low.jpg";
import BigMapAfterImage from "assets/images/after_bigmap.png";
import BigMapBeforeImage from "assets/images/bigmap_before.png";
import AlohaImg from "assets/images/aloha.jpg";

import Footer from "components/Footer";

const Other = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Header />
      <div className="experience">
        <h1>{t("other.pageTitle")}</h1>
        <div className="experience-component">
          <div className="experience-component-title">
            <div className="experience-component-title-text">
              <h2>{t("other.ewh.role")}</h2>
              <h3>{t("other.ewh.location")}</h3>
              <h3>{t("other.ewh.date")}</h3>
            </div>
            <img
              id="EwhLogo"
              src={EwhLogo}
              alt="Engineering World Health Logo"
            />
          </div>

          <ul>
            <li>
              <a
                href="https://www.ewh.org/"
                target="_blank"
                rel="noopener noreferrer">
                {t("other.ewh.linkText")}
              </a>{" "}
              {t("other.ewh.bullet1Rest")}
            </li>
            {t("other.ewh.bullets", { returnObjects: true }).map(
              (bullet, index) => (
                <li key={index}>{bullet}</li>
              )
            )}
          </ul>
          {/* Image Gallery Section */}
          <div className="image-gallery">
            <div className="image-group">
              <img src={SurgicalLampImage} alt="Surgical lamp repair" />
              <p>{t("other.ewh.gallery.surgicalLamp")}</p>
            </div>

            <div className="image-group">
              <img src={CircuitImage} alt="Circuit board repair" />
              <p>{t("other.ewh.gallery.circuit")}</p>
            </div>

            <div className="image-group">
              <img src={SignsLowImage} alt="Signage details" />
              <img src={AfterSignImage} alt="Hospital navigation signs" />
              <p>{t("other.ewh.gallery.signs")}</p>
            </div>

            <div className="image-group">
              <img src={BigMapBeforeImage} alt="Original hospital map" />
              <img src={BigMapAfterImage} alt="Updated hospital map" />
              <p>{t("other.ewh.gallery.map")}</p>
            </div>
          </div>
        </div>
        <div className="experience-component">
          <div className="experience-component-title">
            <div className="experience-component-title-text">
              <h2>{t("other.amm.role")}</h2>
              <h3>{t("other.amm.location")}</h3>
              <h3>{t("other.amm.date")}</h3>
            </div>
          </div>

          <ul>
            <li>
              <a
                href="https://alohamedicalmission.org/"
                target="_blank"
                rel="noopener noreferrer">
                {t("other.amm.linkText")}
              </a>{" "}
              {t("other.amm.bullet1Rest")}
            </li>
            {t("other.amm.bullets", { returnObjects: true }).map(
              (bullet, index) => (
                <li key={index}>{bullet}</li>
              )
            )}
          </ul>
          {/* Image Gallery Section */}
          <div className="image-gallery-center">
            <div className="image-group-center">
              <img src={AlohaImg} alt="Aloha Certification" />
              <p>{t("other.amm.certificateCaption")}</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Other;
